module.exports = __webpack_public_path__ + "google-play-badge.png?db9b21a1c41f3dcd9731e1e7acfdbb57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google-play-badge.png
// module id = 393
// module chunks = 0